module.exports = __webpack_public_path__ + "img/members-bg-shape@dt.906dbe0.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/members-bg-shape@dt.svg
// module id = Uchm
// module chunks = 0